// IDs de rol del backend (tabla `roles`).
// Mantener sincronizado con database/seeders/RolSeeder.php y .env (GANACOL_*).
export const ROLE_IDS = {
    ADMIN: 1,
    JUGADOR: 2,
    DISTRIBUIDOR: 3,
    EMPRESA: 4,
    PUBLIC: 5,
};

export const isAdmin = (auth) => auth?.role_id === ROLE_IDS.ADMIN;
export const isCompany = (auth) => auth?.role_id === ROLE_IDS.EMPRESA;
export const isDistributor = (auth) => auth?.role_id === ROLE_IDS.DISTRIBUIDOR;
